<h2 mat-dialog-title>
  {{
    data.mode === 'prizes' ? 'Полученные призовые места' : 'Награды за очки'
  }}
  — {{ data.season.name }}
</h2>
<mat-dialog-content
  ><p *ngIf="data.mode === 'prizes'">
    Пользователь {{ data.userId }} · только полученные призы.
  </p>
  <p *ngIf="data.mode === 'score-rewards'">
    Все награды за пороги очков этого сезона.
  </p>
  <p class="error" *ngIf="error">
    {{ error }} <button mat-button (click)="reload()">Повторить</button>
  </p>
  <p *ngIf="loading">Загрузка…</p>
  <table
    matSort
    [matSortActive]="sort.active"
    [matSortDirection]="sort.direction"
    (matSortChange)="sortChanged($event)"
  >
    <thead>
      <tr>
        <th>ID</th>
        <th *ngIf="data.mode === 'prizes'">Место</th>
        <th *ngIf="data.mode === 'score-rewards'" mat-sort-header="score">
          Очки
        </th>
        <th>Награда</th>
        <th *ngIf="data.mode === 'prizes'">Количество</th>
        <th *ngIf="data.mode === 'prizes'">Получена (UTC)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td>{{ row.id }}</td>
        <td *ngIf="data.mode === 'prizes'">{{ row.rank ?? '—' }}</td>
        <td *ngIf="data.mode === 'score-rewards'">{{ row.score }}</td>
        <td>
          <ng-container *ngIf="row.reward; else missing"
            ><img
              *ngIf="row.reward.item?.image || row.reward.item?.icon"
              [src]="row.reward.item?.image || row.reward.item?.icon"
              alt=""
            />
            {{ row.reward.item?.name || row.reward.type }} · ID
            {{ row.reward.id }} · значение {{ row.reward.value }}
            <span *ngIf="row.reward.itemId"
              >· предмет {{ row.reward.itemId }}</span
            ></ng-container
          ><ng-template #missing
            >Награда {{ row.rewardId ?? '—' }} недоступна</ng-template
          >
        </td>
        <td *ngIf="data.mode === 'prizes'">{{ row.quantity ?? '—' }}</td>
        <td *ngIf="data.mode === 'prizes'">
          {{ row.createdAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC' }}
        </td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="!loading && !error && !rows.length">Награды не найдены.</p>
  <mat-paginator
    [length]="amount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 20, 50, 100]"
    (page)="page($event)"
  ></mat-paginator> </mat-dialog-content
><mat-dialog-actions align="end"
  ><button mat-button mat-dialog-close>Закрыть</button></mat-dialog-actions
>
